<template>
  <ul class="file-list">
    <li v-for="(file, index) in fileList" :key="index">
      <i class="upload-icon"></i>
      <div class="file-content">
        <span class="file-name">{{file.name}}</span>
        <span class="file-remove font-color-link" @click="delFile(file.name, index)" v-if="isShowDel">{{pageText.del}}</span>
        <a :href="fileDownLoad + '?id='+ file.id +'&url=' + file.url" target="_blank" :title="file.name" v-if="isShowDownLoad">
          <span class="file-remove font-color-link">{{pageText.download}}</span>
        </a>
      </div>
    </li>
  </ul>
</template>

<script>
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'import-file',
    props: {
      isShowDel: {
        type: Boolean,
        default: true
      },
      isShowDownLoad: {
        type: Boolean,
        default: true
      },
      // 需要下载功能的是要传这个参数
      fileDownLoad: {
        type: String,
        default: ''
      },
      fileList: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        pageText
      }
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      delFile (file, index) {
        this.$confirm(this.variableReplace(this.pageText.confirmDel, {n: file}),  this.pageText.tips, {
          confirmButtonText: this.pageText.confirm,
          cancelButtonText: this.pageText.cancel,
          type: 'warning'
        }).then(() => {
          this.$emit('delFile', index)
          this.$message.success(this.pageText.delSuccess)
        }).catch(() => {})
      }
    }
  }
</script>

<style scoped lang="scss">
  .file-list{
    li{
      display: inline-block;
      padding: 10px;
      width: 216px;
      height: 52px;
      box-sizing: border-box;
      background: #F5F5F5;
      border-radius: 3px;
      margin-bottom: 16px;
      margin-right: 16px;
      .upload-icon{
        display: inline-block;
        width: 32px;
        height: 32px;
        background: url($img-url + "159480010026852232.svg") no-repeat;
      }
      .file-content{
        display: inline-block;
        padding-left: 10px;
        font-size: 12px;
        line-height: 17px;
        vertical-align: top;
        .file-name{
          color: #333333;
          display: block;
          width: 140px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
      }
    }
  }
</style>
